import {mutations} from "@/modules/Dashboard/store/mutations";
import {actions} from "@/modules/Dashboard/store/actions";
import {getters} from "@/modules/Dashboard/store/getters";

const state = {

    statusPredictions: [],
    statusPredictionsExpire: null,

    widgets: [],

    panelSizeStats: [],
    panelSizeStatsExpire: null,

    projectActivityStats: [],
    projectActivityStatsExpire: null,

    projectActivityStatsForLastHour: [],
    projectActivityStatsForLastHourExpire: null,

    churnStats: null,

    topProjects: [],
    topProjectsExpired: null,

    // Business Rules Impact
    businessRulesImpact: {
        included: 0,
        excluded: 0,
    },
    businessRulesImpactExpires: null,
    businessRulesImpactLoading: false,
}

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

